import React from 'react';

import type { SVGProps } from '@atlaskit/icon/svg';
import SVG from '@atlaskit/icon/svg';

export const TaskIcon = (props: SVGProps) => (
	<SVG {...props}>
		<rect width="24" height="24" fill="none" fillOpacity="0.01" />
		<rect width="24" height="24" transform="translate(1 1)" fill="none" fillOpacity="0.01" />
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="M18 4C19.0544 4 19.9182 4.81588 19.9945 5.85074L20 6V18C20 19.0544 19.1841 19.9182 18.1493 19.9945L18 20H6C4.94564 20 4.08183 19.1841 4.00549 18.1493L4 18V6C4 4.94564 4.81588 4.08183 5.85074 4.00549L6 4H18ZM18 6H6V18H18V6ZM15.6199 9.21519L15.7071 9.29289C16.0697 9.65552 16.0956 10.2274 15.7848 10.6199L15.7071 10.7071L11.7071 14.7071C11.3445 15.0697 10.7726 15.0956 10.3801 14.7848L10.2929 14.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.65552 10.9303 9.22737 10.9044 9.61989 11.2152L9.70711 11.2929L11.0002 12.5853L14.2929 9.29289C14.6555 8.93026 15.2274 8.90436 15.6199 9.21519Z"
			fill="currentColor"
		/>
	</SVG>
);
